import { useTransformEvent } from '@ion/api';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import translatePlaybookJson from 'app/shared/translation/integrations/translatePlaybookJson';

export default function useIntegrationOutput({ pipelineIntegration }) {
  const { pipeline } = usePipelinePageContext();

  const [transformEvent, { loading, error, outputEvent, errors, reset }] = useTransformEvent();

  const executePipelineTransform = ({ inputEvent, originalEvent }) => {
    const {
      cluster: { id: clusterId },
    } = pipeline;
    transformEvent({
      playbook: translatePlaybook({ pipelineIntegration }),
      inputEvent,
      originalEvent,
      clusterId,
    });
  };

  return [executePipelineTransform, { loading, error, outputEvent, errors, reset }];
}

export function translatePlaybook({ pipelineIntegration }) {
  const { playbook, pipelineVars } = pipelineIntegration.stagedRevision;
  const { vars, playbookJson, pipeline_variables } = playbook;

  return translatePlaybookJson({
    playbookJson,
    deprecatedPipelineVariables: vars,
    pipelineVars,
    playbookPipelineVariables: pipeline_variables,
  });
}
